// submitStickyBucket.js
'use strict';
import fetch from '../resource/customFetch.js';
import { remoteConfig as remoteConfigDebug } from '../resource/debug.js';
import getResourceUrl from '../resource/getResourceUrl.js';

import getMeData from '../selector/getMeData.js';

const errorLog = remoteConfigDebug.extend('error:stickyBucket');

/**
 * Save which variation of each experiment this user got, so the same account
 * keeps those variations on another device.
 *
 * Fire and forget: the response is ignored and there is no timeout, because
 * nothing is waiting on this.
 *
 * @kind action
 * @param {object} params
 * @param {Object} params.assignments - Every assignment on this device, not
 *   just the new ones.
 * @return {Promise} Action promise.
 * @example
 * dispatch(
 *   submitStickyBucket({ assignments: { 'my-experiment__0': 'variation-b' } })
 * );
 */
const submitStickyBucket =
  ({ assignments }) =>
  async (dispatch, getState) => {
    const accessToken = getMeData(getState(), 'token');

    // Only signed-in users are posted to the backend. A visitor who is not
    // signed in has nothing to save there, so it stays on this device.
    if (!accessToken) return;

    try {
      const url = getResourceUrl({ endpoint: '/ab/experiments' });

      await fetch(url.href, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ assignments }),
      });
    } catch (error) {
      errorLog('failed to submit assignments', { error });
    }
  };

export default submitStickyBucket;
